import {TYPE_PROBLEME} from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case TYPE_PROBLEME.PERMANENT:
        return 'Permanent';
      case TYPE_PROBLEME.TEMPORAIRE:
        return 'Temporaire/ Aléatoire';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/type-probleme.filter.js